// Initialize Firebase
var config = {
    apiKey: "AIzaSyBSiHuC5CYPFglcklfRS8m8auO4FEtmo64",
    authDomain: "live-problem.firebaseapp.com",
    projectId: "live-problem",
    storageBucket: "live-problem.appspot.com",
    messagingSenderId: "1019247139183",
    appId: "1:1019247139183:web:1a894ce92e5d0087f0709a",
    measurementId: "G-KKCRN81N8M"
};
  
export default config;